import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

@Injectable()
export class CommonControlService {

  constructor() { }

  toFormGroup(properties: any[]) {
    const group: any = {};
    let tmpArray: FormArray = new FormArray([]) ;
    properties.forEach(property => {
      if(Array.isArray(property)){
        property.forEach((prop: any) => {
          if (prop.iterable) {
            
            const itemGroup: any = {};
            prop.items.forEach(item => {
              if (!Array.isArray(item.value)) {
                item.value = !!item.value ? [item.value] : [''];
              }
              tmpArray = item.required ?  new FormArray([], Validators.required) : new FormArray([]);
  
             /* if (!element.value || !element.value.length) {
                tmpArray.push(new FormControl(''));
              } else {
                tmpArray.push(new FormControl(element.value));
               /* element.value.forEach((val: any) => {
                  tmpArray.push(new FormControl(val));
                }); 
              } */
              //tmpArray.push(itemGroup[element.key]);
            }); 
            
            group[prop.key] = tmpArray;
          } else {
            const controlValidator = [];
            if(prop.pattern != undefined) controlValidator.push(Validators.pattern(prop.pattern));
            if(prop.maxLength != undefined) controlValidator.push(Validators.maxLength(prop.maxLength));
            if(prop.minLength != undefined) controlValidator.push(Validators.minLength(prop.minLength));
            if(prop.required) controlValidator.push(Validators.required);
            if(prop.type == 'email') controlValidator.push(Validators.pattern("[_a-zA-Z0-9.-]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"));
           // if(prop.type != 'phone') controlValidator.push(WhitespaceValidator.noWhiteSpace);
            if(controlValidator.length > 0)
              group[prop.key] = new FormControl(prop.value || '',controlValidator);
            else
              group[prop.key] = new FormControl(prop.value || '');
          }
          })
      }
    });
    return new FormGroup(group);
  }
}
